<template>
  <div class="modal_wrap customer_new_book" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">사전예약 관리</h1>
          <div class="new_book_close" v-on:click="$emit('close')">
            <img src="@/assets/front/images/new/i_x.png" />
          </div>
        </div>
        <div class="modal_con">
          <div class="con_info">
            <div
              class="info_title"
              :class="{ select_title: isNewBookSelectSKT && isSendButton }"
            >
              SKT 사전예약
            </div>

            <div
              class="info_txt"
              @click="newBookSelect('SKT')"
              :class="{ select_con: isNewBookSelectSKT && isSendButton }"
              v-if="isSKT"
            >
              <div class="txt_1 txt_black_color">
                <div>
                  {{ bookingData.SKT.telecomId }}
                  {{ bookingData.SKT.telecomType }} /
                  {{ bookingData.SKT.telecomUsed.replace(' 이용중', '') }}
                  이용중
                </div>
                <div>
                  {{ bookingData.SKT.telecomUserName }} /
                  {{ bookingData.SKT.telecomBirth }} /
                  {{ bookingData.SKT.telecomPhone }}
                </div>
                <div>
                  {{ bookingData.SKT.telecomDevice }} /
                  {{ bookingData.SKT.telecomColor }}
                </div>
              </div>
              <div class="txt_2" @click="modifyBookingForm('SKT')">
                <div class="txt_2_img">
                  <img src="@/assets/front/images/new/i_mode.svg" alt="" />
                </div>
                <div class="txt_2_btn">수정</div>
              </div>
            </div>

            <div class="info_txt" v-else>
              <div class="txt_1">{{ bookingText }}</div>
              <div class="txt_2" @click="createBookingForm('SKT')">
                <div class="txt_2_img">
                  <img src="@/assets/front/images/new/i_plus_g.svg" alt="" />
                </div>
                <div class="txt_2_btn">작성</div>
              </div>
            </div>
          </div>

          <div class="con_info">
            <div
              class="info_title"
              :class="{ select_title: isNewBookSelectKT && isSendButton }"
            >
              KT 사전예약
            </div>
            <div
              class="info_txt"
              @click="newBookSelect('KT')"
              :class="{ select_con: isNewBookSelectKT && isSendButton }"
              v-if="isKT"
            >
              <div class="txt_1 txt_black_color">
                <div>
                  {{ bookingData.KT.telecomId }}
                  {{ bookingData.KT.telecomType }} /
                  {{ bookingData.KT.telecomUsed.replace(' 이용중', '') }} 이용중
                </div>
                <div>
                  {{ bookingData.KT.telecomUserName }} /
                  {{ bookingData.KT.telecomBirth }} /
                  {{ bookingData.KT.telecomPhone }}
                </div>
                <div>
                  {{ bookingData.KT.telecomDevice }} /
                  {{ bookingData.KT.telecomColor }}
                </div>
              </div>
              <div class="txt_2" @click="modifyBookingForm('KT')">
                <div class="txt_2_img">
                  <img src="@/assets/front/images/new/i_mode.svg" alt="" />
                </div>
                <div class="txt_2_btn">수정</div>
              </div>
            </div>

            <div class="info_txt" v-else>
              <div class="txt_1">{{ bookingText }}</div>
              <div class="txt_2" @click="createBookingForm('KT')">
                <div class="txt_2_img">
                  <img src="@/assets/front/images/new/i_plus_g.svg" alt="" />
                </div>
                <div class="txt_2_btn">작성</div>
              </div>
            </div>
          </div>
          <div class="con_info">
            <div
              class="info_title"
              :class="{ select_title: isNewBookSelectLG && isSendButton }"
            >
              LGU+ 사전예약
            </div>
            <div
              class="info_txt"
              @click="newBookSelect('LG')"
              :class="{ select_con: isNewBookSelectLG && isSendButton }"
              v-if="isLG"
            >
              <div class="txt_1 txt_black_color">
                <div>
                  {{ bookingData.LG.telecomId }}
                  {{ bookingData.LG.telecomType }} /
                  {{ bookingData.LG.telecomUsed.replace(' 이용중', '') }} 이용중
                </div>
                <div>
                  {{ bookingData.LG.telecomUserName }} /
                  {{ bookingData.LG.telecomBirth }} /
                  {{ bookingData.LG.telecomPhone }}
                </div>
                <div>
                  {{ bookingData.LG.telecomDevice }} /
                  {{ bookingData.LG.telecomColor }}
                </div>
              </div>
              <div class="txt_2" @click="modifyBookingForm('LGU+')">
                <div class="txt_2_img">
                  <img src="@/assets/front/images/new/i_mode.svg" alt="" />
                </div>
                <div class="txt_2_btn">수정</div>
              </div>
            </div>

            <div class="info_txt" v-else>
              <div class="txt_1">{{ bookingText }}</div>
              <div class="txt_2" @click="createBookingForm('LGU+')">
                <div class="txt_2_img">
                  <img src="@/assets/front/images/new/i_plus_g.svg" alt="" />
                </div>
                <div class="txt_2_btn">작성</div>
              </div>
            </div>
          </div>
        </div>
        <div class="new_book_agree" v-if="isSendButton">
          <div class="checkbox">
            <label @click="newBookAgree">
              <input type="checkbox" v-model="isAgreeChecked" />
              <span class="agree_txt">개인정보 수집/제공에 동의합니다.</span>
            </label>
          </div>
        </div>
        <div class="modal_btn" v-if="isSendButton">
          <div class="btn_wrap" @click="sendBooking">
            <button class="btn" :disabled="disabled">
              매장에 사전예약 신청하기
            </button>
          </div>
        </div>
        <div class="modal_btn" v-else>
          <div class="btn_wrap" @click="gotoShops">
            <button class="btn">
              사전예약 상담하러 가기
            </button>
          </div>
        </div>
      </div>
    </div>
    <DesignPopup
      :show="designPopup"
      :data="{
        type: 'alert',
        msg: `사전 예약이 신청되었습니다.<br /><br />매장에서 접수를 처리하면 등록하신 번호로 연락을 드릴예정입니다.`,
      }"
      @close="popupClose"
    />
  </div>
</template>

<script>
import {
  mapActions as bookingMapActions,
  mapGetters as bookingMapGetters,
} from '@common/store/modules/booking';
import * as bookingTypes from '@common/store/modules/booking/types';

import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatTypes from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';

import DesignPopup from '@/common/components/modal/DesignPopup';

export default {
  name: 'NewBookModal',
  components: {
    DesignPopup,
  },
  props: {
    chatroom: Object,
    userId: Number,
  },
  data() {
    return {
      isOpen: false,
      disabled: true,
      isNewBookSelectSKT: false,
      isNewBookSelectKT: false,
      isNewBookSelectLG: false,
      isAgreeChecked: false,
      isSendButton: false,
      designPopup: false,
      bookingText: '사전예약서를 등록해 주세요.',
      isTelecomName: '',

      // telecomType: '번호이동',
      // telecomUserName: '신원철',
      // telecomBirth: '83.03.28',
      // telecomPhone: '01012341234',
      // telecomDevice: '갤럭시 S22울트라',
      // telecomColor: '핑크',
      // telecomUsed: 'KT 사용중',
      // telecomId: '',

      bookingId: {
        SKT: '',
        KT: '',
        LG: '',
      },

      selectTelecomList: ['SKT', 'KT', 'LGU+'],
      selectTelecomId: ['SKT', 'KT', 'LG'],

      typeList: ['신규가입', '기기변경', '번호이동'], // 보여지는 값
      typeId: ['NEW', 'CHANGE', 'MNP'], // api로 보내는 값

      telecomList: ['SKT', 'KT', 'LGU+', '알뜰폰'], // 보여지는 값
      telecomId: ['SKT', 'KT', 'LG', 'MVNO'], // api로 보내는 값

      bookingData: {
        SKT: {
          telecomType: '', // 개통유형
          telecomUserName: '', // 이름
          telecomBirth: '', // 생년월일
          telecomPhone: '', // 핸드폰 전화번호
          telecomDevice: '', // 핸드폰
          telecomColor: '', // 핸드폰 색상
          telecomUsed: '', // 사용중인 통신사
          telecomId: '', // 사전예약 통신사
        },
        KT: {
          telecomType: '',
          telecomUserName: '',
          telecomBirth: '',
          telecomPhone: '',
          telecomDevice: '',
          telecomColor: '',
          telecomUsed: '',
          telecomId: '',
        },
        LG: {
          telecomType: '',
          telecomUserName: '',
          telecomBirth: '',
          telecomPhone: '',
          telecomDevice: '',
          telecomColor: '',
          telecomUsed: '',
          telecomId: '',
        },
      },

      isSKT: false,
      isKT: false,
      isLG: false,
    };
  },
  created() {
    this.search();
  },
  computed: {},
  methods: {
    ...chatMapActions([chatTypes.SEND_BOOKING]),
    ...bookingMapActions([bookingTypes.FETCH_BOOKING_LIST]),
    async search() {
      const data = await this[bookingTypes.FETCH_BOOKING_LIST]();
      if (data) {
        data.forEach(element => {
          let foundJoin = this.typeId.indexOf(element.joinType);
          let foundCur = this.telecomId.indexOf(element.currentTelecomId);
          let foundTel = this.selectTelecomId.indexOf(element.telecomId);

          console.log(element);
          if (element.telecomId == 'SKT') {
            console.log('SKT');
            this.bookingId.SKT = element.id;
            this.isSKT = true;

            (this.bookingData.SKT.telecomType = this.typeList[foundJoin]),
              (this.bookingData.SKT.telecomUserName = element.customerName),
              (this.bookingData.SKT.telecomBirth = element.residentNumber),
              (this.bookingData.SKT.telecomPhone = element.customerMobile),
              (this.bookingData.SKT.telecomDevice = element.needModelName),
              (this.bookingData.SKT.telecomId = this.selectTelecomList[
                foundTel
              ]),
              (this.bookingData.SKT.telecomColor = element.needModelColor),
              (this.bookingData.SKT.telecomUsed = this.telecomList[foundCur]);
          } else if (element.telecomId == 'KT') {
            console.log('KT');

            this.bookingId.KT = element.id;
            this.isKT = true;

            (this.bookingData.KT.telecomType = this.typeList[foundJoin]),
              (this.bookingData.KT.telecomUserName = element.customerName),
              (this.bookingData.KT.telecomBirth = element.residentNumber),
              (this.bookingData.KT.telecomPhone = element.customerMobile),
              (this.bookingData.KT.telecomDevice = element.needModelName),
              (this.bookingData.KT.telecomId = this.selectTelecomList[
                foundTel
              ]),
              (this.bookingData.KT.telecomColor = element.needModelColor),
              (this.bookingData.KT.telecomUsed = this.telecomList[foundCur]);
          } else if (element.telecomId == 'LG') {
            console.log('LG');
            console.log(this.telecomList[foundCur]);

            this.bookingId.LG = element.id;
            this.isLG = true;

            (this.bookingData.LG.telecomType = this.typeList[foundJoin]),
              (this.bookingData.LG.telecomUserName = element.customerName),
              (this.bookingData.LG.telecomBirth = element.residentNumber),
              (this.bookingData.LG.telecomPhone = element.customerMobile),
              (this.bookingData.LG.telecomDevice = element.needModelName),
              (this.bookingData.LG.telecomId = this.selectTelecomList[
                foundTel
              ]),
              (this.bookingData.LG.telecomColor = element.needModelColor),
              (this.bookingData.LG.telecomUsed = this.telecomList[foundCur]);
          }
        });
      }
    },
    // 작성 클릭시
    createBookingForm(telecomName) {
      this.$router.push({
        name: 'Booking.BookingForm',
        query: {
          telecomName: telecomName,
          mode: 'CREATE',
          title: '사전예약서 등록하기',
          // uuid: this.chatroom.uuid,
        },
      });
    },
    // 수정 클릭시
    modifyBookingForm(telecomName) {
      var id;
      if (telecomName == 'SKT') {
        id = this.bookingId.SKT;
      } else if (telecomName == 'KT') {
        id = this.bookingId.KT;
      } else if (telecomName == 'LGU+') {
        id = this.bookingId.LG;
      }

      this.$router.push({
        name: 'Booking.BookingForm',
        query: {
          telecomName: telecomName,
          mode: 'MODIFY',
          title: '사전예약서 수정하기',
          id: id,
          // uuid: this.chatroom.uuid,
        },
      });
    },
    // 사전예약 내용 클릭시
    newBookSelect(sel) {
      if (sel == 'SKT') {
        if (this.isNewBookSelectSKT) {
          this.isNewBookSelectSKT = false;
        } else {
          this.isNewBookSelectSKT = true;
          this.isNewBookSelectKT = false;
          this.isNewBookSelectLG = false;

          this.isTelecomName = 'SKT';
        }
      }

      if (sel == 'KT') {
        if (this.isNewBookSelectKT) {
          this.isNewBookSelectKT = false;
        } else {
          this.isNewBookSelectKT = true;
          this.isNewBookSelectSKT = false;
          this.isNewBookSelectLG = false;

          this.isTelecomName = 'KT';
        }
      }

      if (sel == 'LG') {
        if (this.isNewBookSelectLG) {
          this.isNewBookSelectLG = false;
        } else {
          this.isNewBookSelectLG = true;
          this.isNewBookSelectKT = false;
          this.isNewBookSelectSKT = false;

          this.isTelecomName = 'LG';
        }
      }

      if (
        this.isNewBookSelectSKT ||
        this.isNewBookSelectKT ||
        this.isNewBookSelectLG
      ) {
        if (this.isAgreeChecked) {
          this.disabled = false;
        }
      } else {
        this.disabled = true;
      }
    },
    // 동의 클릭시
    newBookAgree() {
      console.log(this.isAgreeChecked);
      if (this.isAgreeChecked) {
        // console.log('on_2');
        this.disabled = true;
      } else {
        // 체크되어있지 않은 상태에서 누른
        // console.log('off_2');
        if (
          this.isNewBookSelectSKT ||
          this.isNewBookSelectKT ||
          this.isNewBookSelectLG
        ) {
          this.disabled = false;
        }
      }
    },
    gotoShops() {
      this.$router.push({ name: 'Shop.List' });
    },
    async sendBooking() {
      console.log(this.chatroom);
      console.log(this.userId);

      console.log(this.isTelecomName);
      console.log(this.bookingData.LG);

      var sendData = '';

      if (this.isTelecomName == 'SKT') {
        sendData = this.bookingData.SKT;
      } else if (this.isTelecomName == 'KT') {
        sendData = this.bookingData.KT;
      } else if (this.isTelecomName == 'LG') {
        sendData = this.bookingData.LG;
      }
      console.log(sendData);
      Object.assign(sendData, {
        storeId: this.chatroom.store.id,
        userId: this.userId,
        uuid: this.chatroom.uuid,
        chatId: this.chatroom.id,
        telecomUsed: sendData.telecomUsed.replace(' 이용중', '') + ' 이용중',
      });
      console.log('666666666');
      console.log(sendData);

      await this[chatTypes.SEND_BOOKING](sendData);

      this.isNewBookSelectSKT = false;
      this.isNewBookSelectKT = false;
      this.isNewBookSelectLG = false;
      this.isSendButton = false;
      this.designPopup = true;
      this.isAgreeChecked = false;
    },
    popupClose() {
      // this.$router.go();
      this.isNewBookSelectSKT = false;
      this.isNewBookSelectKT = false;
      this.isNewBookSelectLG = false;
      this.isSendButton = false;
      this.isAgreeChecked = false;

      this.designPopup = false;
      // this.isOpen = false;
      this.$emit('close');
    },
  },
};
</script>
